import { createSlice } from "@reduxjs/toolkit";
import { localStorageKeys, searchFilterConst } from "../../const";

const initialState = {
  searchFilters: {
    vehicle: {},
    stakeholder: {},
    destination: {},
    eventType: [],
    jobStatus: [],
    job: {},
    fromDate: null,
    toDate: null,
  },
  results: [],
  showPath: {},
  showDirection: {},
  mapSettings: {
    map: localStorage.getItem(localStorageKeys.MAP_SETTINGS.MAP)
      ? parseInt(localStorage.getItem(localStorageKeys.MAP_SETTINGS.MAP))
      : 1,
    markerLimit: 0,
    avoidHighways: true,
  },
  filterList: [searchFilterConst.JOB_STATUS],
  speed: {},
  jobInfo: {},
  advancedDirections: {},
  jobLocation: {},
  unvisitedDirections: null,
  apiCallCount: 0,
};

const missionControlSlice = createSlice({
  name: "missionControl",
  initialState,
  reducers: {
    addToSearchFilter(state, action) {
      const filterLength = Object.keys(
        state.searchFilters[action.payload.type],
      ).length;

      if (filterLength >= state.mapSettings.markerLimit) {
        return state;
      }

      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          [action.payload.type]: {
            ...state.searchFilters[action.payload.type],
            [action.payload.key]: action.payload.value,
          },
        },
      };
    },
    setEvents(state, action) {
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          eventType: action.payload,
        },
      };
    },
    setJobStatus(state, action) {
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          jobStatus: action.payload,
        },
      };
    },
    setSearchFromDate(state, action) {
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          fromDate: action.payload,
        },
      };
    },
    setSearchToDate(state, action) {
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          toDate: action.payload,
        },
      };
    },
    removeFromSearchFilter(state, action) {
      const { [action.payload.id]: _, ...newFilterState } =
        state.searchFilters[action.payload.type];

      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          [action.payload.type]: newFilterState,
        },
      };
    },
    setResults(state, action) {
      const results = action.payload.results.map((res) => res.terminalId);
      return {
        ...state,
        results,
        showPath: results.reduce((obj, item) => {
          obj[item] = false;
          return obj;
        }, {}),
        showDirection: results.reduce((obj, item) => {
          obj[item] = false;
          return obj;
        }, {}),
        speed: results.reduce((obj, item) => {
          obj[item] = 0;
          return obj;
        }, {}),
        advancedDirections: results.reduce((obj, item) => {
          obj[item] = false;
          return obj;
        }, {}),
        jobInfo: action.payload.jobInfo,
      };
    },
    addOrUpdateMapSettings(state, action) {
      return {
        ...state,
        mapSettings: {
          ...state.mapSettings,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    toggleAvoidHighway(state) {
      return {
        ...state,
        mapSettings: {
          ...state.mapSettings,
          avoidHighways: !state.mapSettings.avoidHighways,
        },
      };
    },
    togglePath(state, action) {
      return {
        ...state,
        showPath: {
          ...state.showPath,
          [action.payload]: !state.showPath[action.payload],
        },
      };
    },
    toggleDirections(state, action) {
      return {
        ...state,
        showDirection: {
          ...state.showDirection,
          [action.payload]: !state.showDirection[action.payload],
        },
      };
    },
    toggleAdvancedDirections(state, action) {
      return {
        ...state,
        advancedDirections: {
          ...state.advancedDirections,
          [action.payload]: !state.advancedDirections[action.payload],
        },
      };
    },
    addJobLocation(state, action) {
      return {
        ...state,
        jobLocation: {
          ...state.jobLocation,
          [action.payload.terminalId]: action.payload.data,
        },
      };
    },
    clearSearchFilters(state) {
      return {
        ...state,
        searchFilters: {
          vehicle: {},
          stakeholder: {},
          destination: {},
          eventType: [],
          jobStatus: [],
          job: {},
        },
        results: [],
      };
    },
    setSpeed(state, action) {
      return {
        ...state,
        speed: {
          ...state.speed,
          [action.payload.terminalId]: action.payload.speed,
        },
      };
    },
    setUnvisitedDirections(state, action) {
      return {
        ...state,
        unvisitedDirections: action.payload,
      };
    },
    addOrRemoveFromFilter(state, action) {
      const valueIndex = state.filterList.findIndex(
        (sel) => sel === action.payload,
      );
      if (valueIndex === -1) {
        return {
          ...state,
          filterList: [...state.filterList, action.payload],
        };
      } else {

        let emptyVal = {};
        if (action.payload === 'eventType' || action.payload === 'jobStatus') {
          emptyVal = [];
        } else if (action.payload === 'fromDate' || action.payload === 'toDate') {
          emptyVal = null;
        }

        return {
          ...state,
          searchFilters: {
            ...state.searchFilters,
            [action.payload]: emptyVal,
          },

          filterList: [
            ...state.filterList.slice(0, valueIndex),
            ...state.filterList.slice(valueIndex + 1),
          ],
        };
      }
    },
    incrementApiCount(state) {
      return {
        ...state,
        apiCallCount: state.apiCallCount + 1,
      };
    },
    resetMissionControl() {
      return initialState;
    },
  },
});

export const missionControlActions = missionControlSlice.actions;
export default missionControlSlice;
